<template>
    <div class="billOperationRecord public_Spacing">
        <div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
            <div class="public_criteriaRange">
                <div class="public_oparetionBlock_Menu">
                    <label>发单账号：</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <el-select clearable v-model="ORMTB470CA40" placeholder="请选择" filterable remote :remote-method="filterCustomer">
                                <el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
                                    :label="item.ORMTB410CA00" :value="item.ORMTB410CA00">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label>装货地：</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <el-select clearable v-model="enterpriseTwo" remote :remote-method="filterEnterprise" placeholder="请选择" @change="erpChange">
                                <el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
                                    :label="item.SETTB99CA00" :value="item.SETTB99ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label>物料名称：</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <el-select clearable v-model="materielMo" placeholder="请选择" filterable>
                                <el-option v-for="item in materielOptions" :key="item.SETTB109ID"
                                    :label="item.SETTB109CA00" :value="item.SETTB109ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label>车牌号：</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入"
                                v-model="carNumber" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="public_operatArea">
                <div class="public_operatBtn">
                    <button class="public_saleWater_daochu pulic_cursor" @click="reset">
                        重置
                    </button>
                    <button @click="queryClick" class="public_saleWater_chaxun pulic_cursor">
                        搜索
                    </button>
                </div>
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container">
            <el-table ref="multipleTable" tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%"
                :header-cell-style="{
                    color: 'rgba(255,255,255,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column prop="ORMTB470CA05" label="装货地">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.ORMTB470CA05 }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB470CA33" label="卸货地">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.ORMTB470CA33 }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB470CA01" label="车牌号">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.ORMTB470CA01 }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB470CA07" label="物料名称">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.ORMTB470CA07 }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="ORMTB470CA40" label="发单账号">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.ORMTB410CA04 }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="328">
                    <template slot-scope="scope">
                        <el-button class="public_icon_xiangqing btn_color_yellow" type="primary" size="small"
                            @click="handleLook(scope.row)">查看轨迹</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageMo" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
        <div class="public-dialog1">
            <el-dialog title="运单轨迹" :visible.sync="show" width="70%" :closeOnClickModal="false"
                @open="handleMapDialogOpen" @close="handleMapDialogClose" append-to-body custom-class="sales-waybill-trajectory-dialog">
                <div class="DetailsWater-Dialog">
                    <div id="map-container" style="width: 100%; height: 600px;"></div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
    data() {
        return {
            tableData: [],
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            list: [],
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',
            solelist: [], //权限列表
            userobj: undefined,
            show: false,
            map: null,
            trackLine: null,
            markers: [],
            trackData: {
                pickupPoint: {
                    name: "",
                    time: "",
                    latitude: 0,
                    longitude: 0
                },
                loadingPoint: {
                    name: "",
                    time: "",
                    latitude: 0,
                    longitude: 0
                },
                unloadingPoint: {
                    name: "",
                    time: "",
                    latitude: 0,
                    longitude: 0
                },
                path: []
            },
            enterpriseTwo: '',
            materielMo: '',
            ORMTB470CA40: '',
            carNumber: '',
            enterpriseTwoOptionList: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
      filteredEnterpriseOptions: [],
            materielOptions: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        var path = this.$route.path
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))

        this.userobj = this.$store.state.uobj
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表

        sessionStorage.removeItem(this.currentUrl)
        if (this.historyInfo != null && this.historyInfo != '') {
            this.init()
        }
        this.enterprise0ptions()
        this.loadEnterpriseOptions();
        this.loadEnterpriseOptions()
    },
    // 存储数据
    beforeDestroy() {
        var obj = {
            pageMo: this.pageMo,
            limitMo: this.limitMo,
        }
        sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
    },
    mounted() {

    },
    beforeDestroy() {
        this.destroyMap()
    },
    methods: {
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
        //初始化数据
        init() {
            this.pageMo = this.historyInfo.pageMo
            this.limitMo = this.historyInfo.limitMo
        },

        materielMoPost() {
            var i = (this.enterpriseTwoOptionList || []).findIndex(
                profile => profile.SETTB99ID === this.enterpriseTwo
            )
            var url = '/set/settb109/selectPageList'
            var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
            var data = {
                SETTB109CA03: '',
                SETTB109CA00: '',
                SETTB109CD01: SETTB100ID,
                SETTB99ID: this.enterpriseTwo,
                page: 1,
                limit: 1000,
            }
            var List = [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ]
            this.axios.post(url, data).then(res => {
                if (res.data.code == 200) {
                    this.materielOptions = [...List, ...res.data.data]
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },

        erpChange() {
            if (this.enterpriseTwo != '') {
                this.materielMoPost()
            } else {
                this.materielOptions = [
                    {
                        SETTB109CA00: '全部',
                        SETTB109ID: '',
                    },
                ]
            }
        },
        // 查看轨迹
        handleLook(row) {
            let loadingPoint = {
                name: row.ORMTB470CA05,
                latitude: row.SETTB99CA07,
                longitude: row.SETTB99CA06
            }
            let unloadingPoint = {
                name: row.ORMTB470CA33,
                latitude: row.ORMTB460CA23,
                longitude: row.ORMTB460CA22
            }
            this.fetchTrackData(row.ORMTB470ID, loadingPoint, unloadingPoint)
        },
        fetchTrackData(orderId, loadingPoint, unloadingPoint) {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            this.axios.post('/orm/ormtb470/getTrackForCus', { ORMTB470ID: orderId }).then(res => {
                setTimeout(() => {
                    loading.close()
                }, 400)
                if (res.data.code == 200) {
                    let pickupPoint = {
                        name: "接单位置",
                        latitude: res.data.data.trackArray[0].latitude,
                        longitude: res.data.data.trackArray[0].longitude
                    }
                    this.trackData = {
                        pickupPoint: pickupPoint,
                        loadingPoint: loadingPoint,
                        unloadingPoint: unloadingPoint,
                        path: res.data.data.trackArray
                    }

                    if (this.map) {
                        this.drawTrack()
                    }
                    this.show = true;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            }).catch(() => {
                loading.close()
            })

        },
        reset() {
            this.enterpriseTwo = ''
            this.materielMo = ''
            this.ORMTB470CA40 = ''
            this.carNumber = ''
            this.pageMo = 1
            this.limitMo = 10
            this.tableData = []
            this.pageList()
        },
        // 查询
        queryClick() {
            this.pageMo = 1
            this.limitMo = 10
            this.tableData = []
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = { ORMTB470CA40: this.ORMTB470CA40, ORMTB470CA04: this.enterpriseTwo, ORMTB470CA06: this.materielMo, ORMTB470CA01: this.carNumber, page: this.pageMo, limit: this.limitMo }
            var url = '/orm/ormtb470/selectPageListForCus'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        var data = res.data.data
                        this.tableData = data
                        this.pagingPageMo = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
        // 弹窗打开时初始化地图
        handleMapDialogOpen() {
            this.$nextTick(() => {
                this.initMap()
            })
        },

        // 弹窗关闭时清理地图
        handleMapDialogClose() {
            this.destroyMap()
        },

        // 初始化地图
        initMap() {
            // 如果已经初始化则直接绘制轨迹
            if (this.AMap && this.map) {
                this.drawTrack()
                return
            }

            AMapLoader.load({
                key: 'ddc3f919a2106d25341cb70eba4b5c1e',
                version: '2.0',
                plugins: ['AMap.Marker', 'AMap.Polyline', 'AMap.ToolBar', 'AMap.Scale']
            }).then((AMap) => {
                this.AMap = AMap
                this.map = new AMap.Map('map-container', {
                    zoom: 10,
                    center: [this.trackData.pickupPoint.longitude, this.trackData.pickupPoint.latitude],
                    resizeEnable: true,
                    viewMode: '2D'
                })

                this.map.addControl(new AMap.ToolBar())
                this.map.addControl(new AMap.Scale())

                this.drawTrack()
            }).catch(e => {
                this.$message.error('地图加载失败，请稍后重试')
            })
        },

        // 绘制轨迹
        drawTrack() {
            if (!this.map) {
                console.error('地图未初始化')
                return
            }

            if (!this.trackData.path || this.trackData.path.length === 0) {
                console.error('无轨迹数据:', this.trackData)
                this.$message.warning('无轨迹数据可显示')
                return
            }

            this.clearMap()

            // 转换路径数据格式
            const path = this.trackData.path.map(point => {
                if (!point.longitude || !point.latitude) {
                    console.warn('无效的轨迹点:', point)
                }
                return [point.longitude, point.latitude]
            }).filter(point => point[0] && point[1]) // 过滤无效点
            if (path.length < 2) {
                this.$message.warning('有效轨迹点不足，无法绘制轨迹线')
                return
            }

            // 绘制轨迹线
            this.trackLine = new this.AMap.Polyline({
                path: path,
                isOutline: true,
                outlineColor: '#ffeeff',
                borderWeight: 1,
                strokeColor: '#3366FF',
                strokeOpacity: 0.8,
                strokeWeight: 5,
                strokeStyle: 'solid',
                lineJoin: 'round',
                lineCap: 'round',
                zIndex: 50
            })
            this.map.add(this.trackLine)

            // 添加关键点标记
            this.addMarker(
                [this.trackData.pickupPoint.longitude, this.trackData.pickupPoint.latitude],
                `起点: ${this.trackData.pickupPoint.name}`,
                require('@/assets/images/qidian.png'),
                'pickup' // 起点类型
            )

            this.addMarker(
                [this.trackData.loadingPoint.longitude, this.trackData.loadingPoint.latitude],
                `装货点: ${this.trackData.loadingPoint.name}`,
                require('@/assets/images/zhuanghuodian.png'),
                'loading' // 装货点类型
            )

            this.addMarker(
                [this.trackData.unloadingPoint.longitude, this.trackData.unloadingPoint.latitude],
                `卸货点: ${this.trackData.unloadingPoint.name}`,
                require('@/assets/images/xiehuodian.png'),
                'unloading' // 卸货点类型
            )

            this.centerMap()
        },

        // 添加标记点
        addMarker(position, content, iconUrl, pointType) {
            const marker = new this.AMap.Marker({
                position: position,
                icon: new this.AMap.Icon({
                    image: iconUrl,
                    size: new this.AMap.Size(24, 32),
                    imageSize: new this.AMap.Size(24, 32)
                }),
                offset: new this.AMap.Pixel(-12, -32)
            })

            marker.setMap(this.map)

            // 根据标记点类型决定是否添加信息窗口
            if (pointType === 'loading' || pointType === 'unloading') {
                const infoContent = `
      <div class="custom-info-window">
        <div class="info-title">${content.split('<br/>')[0]}</div>
        ${content.includes('<br/>') ? `<div class="info-detail">${content.split('<br/>')[1]}</div>` : ''}
      </div>
    `

                const infoWindow = new this.AMap.InfoWindow({
                    content: infoContent,
                    offset: new this.AMap.Pixel(0, -35),
                    isCustom: true
                })

                // 鼠标移入显示
                marker.on('mouseover', () => {
                    infoWindow.open(this.map, marker.getPosition())
                })

                // 鼠标移出隐藏
                marker.on('mouseout', () => {
                    infoWindow.close()
                })

                // 保留点击事件（如果需要）
                // marker.on('click', () => {
                //     infoWindow.open(this.map, marker.getPosition())
                // })
            }

            this.markers.push(marker)
        },

        // 居中显示轨迹
        centerMap() {
            if (!this.map || !this.trackLine) return

            this.map.setFitView(this.markers.concat(this.trackLine), {
                padding: [100, 100, 100, 100],
                animate: true
            })
        },

        // 清除地图上的轨迹和标记
        clearMap() {
            if (this.trackLine) {
                this.map.remove(this.trackLine)
                this.trackLine = null
            }

            this.markers.forEach(marker => {
                this.map.remove(marker)
            })
            this.markers = []
        },

        // 销毁地图
        destroyMap() {
            this.clearMap()
            if (this.map) {
                this.map.destroy()
                this.map = null
            }
            this.AMap = null
        }
    },

}
</script>

<style scoped>

.el-button+.el-button {
    margin-left: 0px !important;
}

/deep/.el-table td {
    font-size: 14px !important;
}

/* 搜索框 */
.search_box {
    width: 100%;
    height: 60px;
    background: #fff;
    padding: 10px 20px;
}

/deep/.el-table .has-gutter tr {
    background: #199fff !important;
}

.public_operatArea {
    display: flex;
    justify-content: end;
}

.pulic_cursor {
    width: 48px !important;
    height: 32px !important;
    line-height: 32px !important;
    text-align: center;
    border-radius: 4px !important;
    padding: 0 !important;
    font-size: 14px !important;
}

.public_operatBtn {
    display: flex;
    justify-content: end;
}

.public_operatBtn_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px !important;
    height: 32px !important;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: 20px;
    margin-left: 10px;
}


/deep/.custom-info-window {
    min-width: 180px;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    font-family: 'Microsoft YaHei', sans-serif;
    color: #fff;
    font-size: 16px;
    text-align: center;
    background-color: #2e67b1;
}
</style>
<style>
.sales-waybill-trajectory-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-waybill-trajectory-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-waybill-trajectory-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-waybill-trajectory-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-waybill-trajectory-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
